import findImageFormat from './findImageFormat'

const carResource = (car) => {

    let featuredImage = '';
    if(car.featuredImage) {
        if (typeof car.featuredImage === "string") {
            featuredImage = car.featuredImage
        } else if (typeof car.featuredImage === "object") {
            featuredImage = car.featuredImage.files[0].url
        } else if (car.featuredImage !== null) {
            featuredImage = findImageFormat(car.featuredImage, '800x')[0].src
        }
    }

    return {
        waykeId: car._id,
        itemPublished: car.itemPublished,
        featuredImage: featuredImage,
        fuelType: car.fuelType,
        gearboxType: car.gearboxType,
        manufacturer: car.manufacturer,
        modelSeries: car.modelSeries,
        mileage: car.mileage,
        modelYear: car.modelYear,
        segment: car.properties?.segment ?? '',
        isCarrier: car.isCarrier ? true : false,
        price: car.price,
        oldPrice: car.oldPrice,
        leasingPrice: car.leasingPrice,
        monthlyCost: car.payment.monthlyCost,
        title: car.title,
        salesName: car.salesName,
        shortDescription: car.shortDescription,
        keywords: car.keywords,
        state: car.state,
        city: car.city,
        color: car.properties?.colorName ?? '',
        chassis: car.propterties?.chassis ?? '',
        hasCampaigns: false, // TOOD: This should be fixed later
    }

}

export default carResource